import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import customFetch from './lib/customFetch';
import {ENVIRONMENT} from "@/environments/environment.ts";
import {setError, setValidationError} from "@/lib/errorHandler.ts";

const urlGetResources = (id: number, system: string) =>
  `${ENVIRONMENT.authApiPath.basePath}/culture/GetStringResources?Id=${id}&System=${system}`;

export async function loadTranslations(cultureId) {
  try{
    const expirationTime = localStorage.getItem('expirationTime');
    const savedCultureId = localStorage.getItem('cultureId');
    const currentTime = new Date().getTime();
    const translations = JSON.parse(localStorage.getItem('translations'));

    if (
        translations &&
        expirationTime &&
        currentTime < Number.parseInt(expirationTime) &&
        savedCultureId == cultureId
    ) {
      i18n.addResourceBundle('culture', 'translation', translations, true, true);
    } else {
      const loadedTranslations = await customFetch<any>(urlGetResources(cultureId, 'DVS Auth'));
      
      if(loadedTranslations?.errorMessage){
        setError(loadedTranslations);
        return loadedTranslations;
      }
      
      i18n.addResourceBundle('culture', 'translation', loadedTranslations.data, true, true);
      localStorage.setItem('translations', JSON.stringify(loadedTranslations.data));
      localStorage.setItem('expirationTime', String(new Date().getTime() + 60 * 1000 * 300));
      localStorage.setItem('cultureId', cultureId);
    }

    i18n.changeLanguage('culture');
  }
  catch(e){
    return setValidationError(e?.message);
  }
}

i18n.use(initReactI18next).init({
  resources: {
    culture: {translation: {}},
  },
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
